class SettingsNavigationItem {
  constructor(node) {
    this.node = node;
    if (this._isAssignment()) {
      const field = document.getElementById(this.node.dataset.settingsId);
      this._countAssigmentLists(field);
      this._watchAssignment(field);
    }
  }

  // Notifications
  setNotifications(number) {
    this.node.querySelector(".setting-notification").dataset.settingsNotifications = number;
  }

  setCounter(number) {
    this.node.querySelector(".setting-notification").dataset.nonCriticalNotification = `(${number})`;
  }

  incrementNotification() {
    this._calculateAndSetNotification();
  }

  decrementNotification() {
    this._calculateAndSetNotification(true);
  }

  _calculateAndSetNotification(decrement) {
    let notifications = this._getNotifications();
    decrement ? notifications-- : notifications++;
    this.setNotifications(notifications);
  }

  _getNotifications(id) {
    const itemNotificationWrapper = this.node.querySelector(".setting-notification");
    if (itemNotificationWrapper.dataset.settingsNotifications) {
      return parseInt(itemNotificationWrapper.dataset.settingsNotifications, 10);
    } else {
      return 0;
    }
  }

  // Count Assignments
  _isAssignment() {
    if (document.getElementById(this.node.dataset.settingsId).closest(".assignment-lists")) {
      return true;
    } else {
      return false;
    }
  }

  _watchAssignment(field) {
    const list = field.querySelector(".add-on-list");
    // Read-only assignment lists (large, import-managed) render a count summary
    // instead of an editable list, so there is no `.add-on-list` to observe.
    if (!list) {
      return;
    }

    const observer = new MutationObserver(() => {
      this._countAssigmentLists(field);
    });
    observer.observe(list, {
      childList: true,
      subtree: true,
    });
  }

  _countAssigmentLists(field) {
    const list = field.querySelector(".add-on-list");
    if (!list) {
      // Read-only lists expose their member count via a data attribute rather than rendering each item.
      const summary = field.querySelector(".assignment-list-read-only[data-assignment-count]");
      this.setCounter(summary ? parseInt(summary.dataset.assignmentCount, 10) : 0);
      return;
    }

    this.setCounter(field.querySelectorAll(".add-on-list-item:not(.nested-list-container .add-on-list-item)").length);
  }
}

window.SettingsNavigationItem = SettingsNavigationItem;
